function BeerPouring6(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={65}
      height={140}
      viewBox="0 0 65 140"
      id="beer-pouring-6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.43 11.347h63.63c.55 51.121-22.893 102.209-11.9 125.86a2.327 2.327 0 01-2.32 2.308H14.652a2.325 2.325 0 01-2.319-2.308C23.326 113.556-.117 62.468.431 11.347z"
        fill="#C0BFBF"
      />
      <path
        d="M2.685 13.81H61.97c0 52.684-18.07 87.598-13.553 115.989H16.237C20.755 101.408 2.685 66.494 2.685 13.81z"
        fill="#D4D4D4"
      />
      <path
        d="M29.917 104.287a2.398 2.398 0 002.404 2.393 2.399 2.399 0 002.406-2.393 2.399 2.399 0 00-2.406-2.392 2.398 2.398 0 00-2.404 2.392z"
        fill="#D4D4D4"
      />
      <path
        d="M44.38 69.56c0 1.731 1.41 3.135 3.15 3.135a3.142 3.142 0 003.15-3.134 3.142 3.142 0 00-3.15-3.136 3.143 3.143 0 00-3.15 3.136z"
        fill="#F8F8F8"
      />
      <path
        d="M32.331 140h17.594a2.327 2.327 0 002.32-2.308c-2.093-4.505-2.938-10.003-2.936-16.308.002-26.413 14.843-66.97 14.847-107.754 0-.6-.004-1.198-.01-1.798H32.331v1.978h29.642c0 52.683-18.07 87.597-13.552 115.988H32.33V140z"
        fill="#999"
      />
      <path
        d="M32.327 129.799h16.09C43.898 101.408 61.968 66.494 61.968 13.81H32.327v88.085a2.399 2.399 0 012.406 2.392 2.399 2.399 0 01-2.406 2.393v23.119zm15.2-63.377a3.142 3.142 0 013.15 3.136 3.142 3.142 0 01-3.15 3.134 3.143 3.143 0 01-3.15-3.133 3.143 3.143 0 013.15-3.137z"
        fill="#D4D4D4"
      />
      <path
        d="M32.32 106.68a2.399 2.399 0 002.407-2.393 2.399 2.399 0 00-2.406-2.392v4.785zM47.53 72.695a3.142 3.142 0 003.15-3.134 3.142 3.142 0 00-3.15-3.136 3.143 3.143 0 00-3.15 3.136c0 1.73 1.41 3.134 3.15 3.134z"
        fill="#D4D4D4"
      />
      <path
        d="M9.713 14.922H4.27c-.697 32.762 15.21 75.936 14.374 113.974 3.069-51.503-9.57-65.427-8.931-113.974z"
        fill="#F8F8F8"
      />
      <path
        d="M43.338 50.825c0 1.754.938 3.175 2.092 3.175 1.156 0 2.093-1.421 2.093-3.175 0-1.755-.937-3.176-2.093-3.176-1.154 0-2.092 1.421-2.092 3.176zM19.573 45.307a3.143 3.143 0 003.152 3.134c1.74 0 3.15-1.404 3.15-3.134a3.143 3.143 0 00-3.15-3.136 3.144 3.144 0 00-3.152 3.136zM20.566 34.499c0 2.324 1.894 4.207 4.229 4.207 2.336 0 4.228-1.883 4.228-4.207 0-2.323-1.892-4.208-4.228-4.208-2.335 0-4.23 1.885-4.23 4.208z"
        fill="#D4D4D4"
      />
      <ellipse cx={32.386} cy={12.644} rx={31.965} ry={3.294} fill="#F8F8F8" />
      <path
        d="M60.698 28.061s5.831-14.95-2.71-21.18c-2.544-1.855-5.948-3.192-13.159-2.27C37.454 2.08 27.232.135 23.607.019 13.679-.3 13.249 3.445 7.546 7.505c-5.649 5.606.008 20.556.008 20.556h53.144z"
        fill="#F8F8F8"
      />
      <path
        d="M2.766 31.035c1.516 24.585 15.916 71.486 13.728 98.719H49.55s-5.098-12.104 3.618-47.658c5.008-20.425 8.338-54.844 8.338-54.844s-10.548.451-26.15-6.051c-15.6-6.503-32.59 9.834-32.59 9.834z"
        fill="url(#prefix__paint0_linear_14338_42019)"
      />
      <path
        d="M17.922 47.299c.837 0 1.515-.508 1.515-1.135s-.678-1.135-1.515-1.135c-.837 0-1.516.508-1.516 1.135s.679 1.135 1.516 1.135zM40.285 101.765a1.136 1.136 0 10.001-2.272 1.136 1.136 0 00-.001 2.272zM40.835 52.057c0 .998.81 1.806 1.808 1.806 1 0 1.81-.808 1.81-1.806 0-.997-.81-1.806-1.81-1.806-.998 0-1.808.809-1.808 1.806zM21.838 61.989a2.711 2.711 0 002.712 2.709c1.5 0 2.716-1.213 2.716-2.71a2.712 2.712 0 00-2.716-2.708 2.711 2.711 0 00-2.712 2.709zM21.34 92.687c.628 0 1.137-.677 1.137-1.512 0-.837-.509-1.514-1.137-1.514s-1.137.677-1.137 1.514c0 .835.509 1.512 1.137 1.512z"
        fill="#F8F8F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.907 13.36c-2.704 1.537-15.756 2.703-31.45 2.703-15.694 0-28.746-1.166-31.45-2.703-.338.192-.515.39-.515.592 0 1.819 14.311 3.294 31.965 3.294 17.653 0 31.964-1.475 31.964-3.294 0-.202-.176-.4-.514-.592z"
        fill="#C0BFBF"
      />
      <path
        d="M49.819 15.377c-.956 13.141 4.934 24.357-1.892 24.357-6.827 0-1.1-11.802-3.256-24.357-.718-1.005 5.986-.586 5.148 0z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_14338_42019"
          x1={49.632}
          y1={117.119}
          x2={15.784}
          y2={117.119}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAF3F" />
          <stop offset={1} stopColor="#F89730" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default BeerPouring6;
